import React, { useEffect, useState } from "react";

import {
    getSettlements,
    getSettlementStats,
} from "../services/adminApi";

import SettlementHeader from "../components/settlements/SettlementHeader";
import SettlementStats from "../components/settlements/SettlementStats";
import SettlementFilters from "../components/settlements/SettlementFilters";
import SettlementTable from "../components/settlements/SettlementTable";
import LoadingSettlements from "../components/settlements/LoadingSettlements";
import EmptySettlements from "../components/settlements/EmptySettlements";

import "../styles/Settlements.css";

const Settlements = () => {

    const [settlements, setSettlements] = useState([]);
    const [stats, setStats] = useState({});
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        loadData();
    }, []);

    const loadData = async () => {

        try {

            const [settlementRes, statsRes] = await Promise.all([
                getSettlements(),
                getSettlementStats(),
            ]);

            setSettlements(settlementRes.data.settlements || []);
            setStats(statsRes.data.stats || {});

        } catch (error) {

            console.error(error);

        } finally {

            setLoading(false);

        }

    };

    if (loading) {
        return <LoadingSettlements />;
    }

    return (

        <div className="settlements-page">

            <SettlementHeader />

            <SettlementStats stats={stats} />

            <SettlementFilters />

            {

                settlements.length === 0 ?

                    <EmptySettlements />

                    :

                    <SettlementTable settlements={settlements} />

            }

        </div>

    );

};

export default Settlements;